import './PanelHead.css'

/**
 * The head of a panel switched by a section strip: which section this is, and one line
 * on what it holds.
 *
 * The strip marks the current section, but the strip is above the panel and the reader
 * is in the panel. The head says it again where they are looking, and the line under it
 * says what the content below is for — which a table's column headings or a card's own
 * titles do not.
 *
 * A panel whose content already opens with a titled card passes only `about`: the line
 * alone, so the name is not said twice within a hand's width.
 */
export default function PanelHead({ title, about }) {
  if (!title && !about) return null

  return (
    <header className="panel-head">
      {title && (
        <h2 className="panel-head__title">
          <bdi>{title}</bdi>
        </h2>
      )}
      {about && (
        <p className="panel-head__about">
          <bdi>{about}</bdi>
        </p>
      )}
    </header>
  )
}
